module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00576.842632b1.jpg";